(()=>{
// Exact lesson grouping, sequence, links, metadata and start times from published V5.
const curriculum = {
  "levels": [
    {
      "id": "foundations",
      "number": "01",
      "kicker": "Beginner · NSABERS Spin Series 1 of 3",
      "name": "Spin Foundations",
      "summary": "Start here. Build the wrist paths, turning control, and Obi-Ani foundation used throughout the academy.",
      "sample": "Figure 8, Turning, Obi-Ani, High Whip",
      "lessons": [
        {
          "number": "01",
          "title": "1.1 Figure 8",
          "id": "SL_AQG53hdo",
          "duration": "1:56",
          "creator": "LightsaberBrit",
          "note": "Establish the wrist path that every clean spin depends on."
        },
        {
          "number": "02",
          "title": "1.2 Reverse Figure 8",
          "id": "0QkvnakUV9w",
          "duration": "2:18",
          "creator": "LightsaberBrit",
          "note": "Mirror the core pattern and build equal control on both sides."
        },
        {
          "number": "03",
          "title": "1.3 Turning",
          "id": "yiCVHgB5_l4",
          "duration": "1:54",
          "creator": "LightsaberBrit",
          "note": "Keep the blade path consistent while the body changes direction."
        },
        {
          "number": "04",
          "title": "1.4 Obi-Ani",
          "id": "YVO7g09LZI8",
          "duration": "2:59",
          "creator": "LightsaberBrit",
          "note": "Build the iconic continuous rotation with controlled timing."
        },
        {
          "number": "05",
          "title": "1.5 Reverse Obi-Ani",
          "id": "Ws2OuvBDpaY",
          "duration": "2:50",
          "creator": "LightsaberBrit",
          "note": "Reverse the full loop without losing the rhythm of the movement."
        },
        {
          "number": "06",
          "title": "1.6 High Whip",
          "id": "ZPt4tTljFyQ",
          "duration": "2:23",
          "creator": "LightsaberBrit",
          "note": "Add height and energy while keeping the path compact."
        }
      ]
    },
    {
      "id": "flow",
      "number": "02",
      "kicker": "Intermediate · NSABERS Spin Series 2 of 3",
      "name": "Flow & Transitions",
      "summary": "Continue after Foundations. Add reverse grip, hand changes, overhead planes, and larger body pathways.",
      "sample": "Reverse Grip, Hand Switch, Helicopter, Around the World",
      "lessons": [
        {
          "number": "01",
          "title": "2.1 Reverse Grip Figure 8",
          "id": "H80sYnlztRo",
          "duration": "1:22",
          "creator": "LightsaberBrit",
          "note": "Transfer the foundation pattern into a reverse grip."
        },
        {
          "number": "02",
          "title": "2.2 Reverse Grip Switch",
          "id": "4ppkfNT-_e8",
          "duration": "3:26",
          "creator": "LightsaberBrit",
          "note": "Change grip without breaking the rhythm of the spin."
        },
        {
          "number": "03",
          "title": "2.3 Reverse Grip Obi-Ani",
          "id": "PU2qix-WcGQ",
          "duration": "2:51",
          "creator": "LightsaberBrit",
          "note": "Rebuild the continuous Obi-Ani loop in reverse grip."
        },
        {
          "number": "04",
          "title": "2.4 Simple Hand Switch",
          "id": "Qu03lafkn0Q",
          "duration": "2:38",
          "creator": "LightsaberBrit",
          "note": "Move the saber cleanly between hands while maintaining flow."
        },
        {
          "number": "05",
          "title": "2.5 Helicopter Spin",
          "id": "tu2XDdrW1O8",
          "duration": "1:28",
          "creator": "LightsaberBrit",
          "note": "Control a horizontal rotation plane above the body."
        },
        {
          "number": "06",
          "title": "2.6 Around the World",
          "id": "O6bh2bBTS_E",
          "duration": "1:14",
          "creator": "LightsaberBrit",
          "note": "Connect the saber through a larger body-level pathway."
        }
      ]
    },
    {
      "id": "performance",
      "number": "03",
      "kicker": "Advanced · NSABERS Spin Series 3 of 3",
      "name": "Performance Flow",
      "summary": "Continue after Flow & Transitions. Add releases, catches, turning strikes, and performance-ready combinations.",
      "sample": "Butterfly, Palm Spin, Toss & Catch, Making It Flow",
      "lessons": [
        {
          "number": "01",
          "title": "3.1 Butterfly Switch",
          "id": "wuYL6UsPy-g",
          "duration": "1:31",
          "creator": "LightsaberBrit",
          "note": "Change hands inside a fluid, performance-ready pattern."
        },
        {
          "number": "02",
          "title": "3.2 Palm Spin",
          "id": "VKJfZa2PU0s",
          "duration": "1:17",
          "creator": "LightsaberBrit",
          "note": "Balance momentum and presentation across an open palm."
        },
        {
          "number": "03",
          "title": "3.3 Toss and Catch",
          "id": "4wqHYiPq_Fs",
          "duration": "1:39",
          "creator": "LightsaberBrit",
          "note": "Introduce release and recovery with a controlled catch."
        },
        {
          "number": "04",
          "title": "3.4 Advanced Helicopter",
          "id": "tThrGi2HITk",
          "duration": "1:04",
          "creator": "LightsaberBrit",
          "note": "Extend the horizontal spin into a larger performance move."
        },
        {
          "number": "05",
          "title": "3.5 Turning Strikes",
          "id": "RPheN364ptk",
          "duration": "1:37",
          "creator": "LightsaberBrit",
          "note": "Add direction and intent to a clean rotational pattern."
        },
        {
          "number": "06",
          "title": "3.6 Making It Flow",
          "id": "FbwOO09idpw",
          "duration": "1:21",
          "creator": "LightsaberBrit",
          "note": "Combine the complete 18-lesson series into one continuous sequence."
        }
      ]
    },
    {
      "id": "extensions",
      "number": "04",
      "kicker": "Experienced spinners · Choose by skill",
      "name": "Skill Extensions",
      "summary": "Optional techniques and character-inspired combinations. These are electives, not a required sequence.",
      "sample": "Skip-Catch, Infinity, Acolyte, Obi-Wan, Double Blade, Grievous",
      "lessons": [
        {
          "number": "01",
          "title": "Continuous Skip-Catch",
          "id": "mTTzjyVEmaI",
          "duration": "6:15",
          "creator": "Darth Damian",
          "note": "Use a skip-catch to keep a spin moving without interruption."
        },
        {
          "number": "02",
          "title": "Infinity Spin",
          "id": "VMqEYhgD-_U",
          "duration": "0:57",
          "creator": "Blayne's Adventures",
          "note": "Start with a fast, approachable Infinity Spin pattern."
        },
        {
          "number": "03",
          "title": "The Acolyte Three-Part Spin",
          "id": "1XvIJDPlDn4",
          "duration": "0:58",
          "creator": "Blayne's Adventures",
          "note": "Learn a compact three-part sequence inspired by The Acolyte."
        },
        {
          "number": "04",
          "title": "Obi-Wan Inspired Spin",
          "id": "CAcEsKKhpqw",
          "duration": "5:50",
          "creator": "Blayne's Adventures",
          "note": "Learn a longer Attack of the Clones-inspired Obi-Wan sequence."
        },
        {
          "number": "05",
          "title": "Double-Bladed Obi-Ani",
          "id": "hgEr4uNF-JQ",
          "duration": "4:33",
          "creator": "Blayne's Adventures",
          "note": "Transfer the Obi-Ani pathway to a Darth Maul-style double blade."
        },
        {
          "number": "06",
          "title": "General Grievous Inspired Spin",
          "id": "FywEu853e8A",
          "duration": "6:06",
          "creator": "Blayne's Adventures",
          "note": "Coordinate a theatrical sequence inspired by General Grievous."
        },
        {
          "number": "07",
          "title": "Obi-Ani Attack Spin",
          "id": "VIlXobC3Z3w",
          "duration": "3:19",
          "creator": "Alexis Nieshalla",
          "note": "Carry the Obi-Ani into a more directional attack variation."
        }
      ]
    },
    {
      "id": "alexis-forms",
      "number": "05",
      "kicker": "Reference library · Alexis Nieshalla",
      "name": "Explore the Seven Forms",
      "summary": "A backstory-and-demonstration library covering the movement character of Forms I–VII. Explore in any order.",
      "sample": "Shii-Cho, Makashi, Soresu, Ataru, Djem So, Niman, Vaapad",
      "lessons": [
        {
          "number": "01",
          "title": "Form I: Shii-Cho",
          "id": "IJJUQavBQzY",
          "duration": "5:54",
          "creator": "Alexis Nieshalla",
          "note": "Understand the foundational form and its broad, direct movement vocabulary."
        },
        {
          "number": "02",
          "title": "Form II: Makashi",
          "id": "rl-klkeDel4",
          "duration": "4:14",
          "creator": "Alexis Nieshalla",
          "note": "Study the precise, duel-focused form associated with Count Dooku."
        },
        {
          "number": "03",
          "title": "Form III: Soresu",
          "id": "QNMH895wufw",
          "duration": "3:44",
          "creator": "Alexis Nieshalla",
          "note": "Explore a compact defensive form built around economy and protection."
        },
        {
          "number": "04",
          "title": "Form IV: Ataru",
          "id": "LcXqqE3jD-w",
          "duration": "6:13",
          "creator": "Alexis Nieshalla",
          "note": "See how speed, mobility, and acrobatic energy define Ataru."
        },
        {
          "number": "05",
          "title": "Form V: Shien & Djem So",
          "id": "QHhsqqG7mMU",
          "duration": "9:11",
          "creator": "Alexis Nieshalla",
          "note": "Compare Form V's redirection and power-driven counterattacks."
        },
        {
          "number": "06",
          "title": "Form VI: Niman",
          "id": "FDoHweTjopY",
          "duration": "7:39",
          "creator": "Alexis Nieshalla",
          "note": "Learn the balanced form that blends techniques from earlier disciplines."
        },
        {
          "number": "07",
          "title": "Form VII: Juyo & Vaapad",
          "id": "posbSucPOLY",
          "duration": "8:48",
          "creator": "Alexis Nieshalla",
          "note": "Finish with the aggressive intensity and controlled edge of Form VII."
        }
      ]
    },
    {
      "id": "flow-analysis",
      "number": "06",
      "kicker": "Bonus analysis · Starts at 4:32",
      "name": "Bonus Flow Analysis",
      "summary": "Watch how continuous loops and technicality are applied in context. This is observation material, not a required lesson.",
      "sample": "Excerpt from “I became a BALISONG JEDI”",
      "lessons": [
        {
          "number": "01",
          "title": "Loops & Technicality — Starts at 4:32",
          "id": "kr9KGLzTHaY",
          "duration": "17:12",
          "creator": "Benshamin Flips",
          "start": 272,
          "note": "An optional excerpt from “I became a BALISONG JEDI.” Begin at 4:32 to study continuous saber loops and technicality."
        }
      ]
    }
  ],
  "alternates": [
    {
      "number": "01",
      "title": "Spinning Foundations",
      "id": "xp45kCjX8xo",
      "duration": "5:55",
      "creator": "Darth Damian",
      "note": "Build a reusable spinning base for lightsaber, sword, and staff."
    },
    {
      "number": "02",
      "title": "Figure 8 Flow",
      "id": "6QewJ5wWlpQ",
      "duration": "8:56",
      "creator": "Darth Damian",
      "note": "Turn the familiar Figure 8 into a complete movement language."
    },
    {
      "number": "03",
      "title": "Obi-Ani Masterclass",
      "id": "gcpAYfyDips",
      "duration": "8:33",
      "creator": "Darth Damian",
      "note": "Break the Obi-Ani down into repeatable, connected mechanics."
    },
    {
      "number": "04",
      "title": "Around the World",
      "id": "VCtM3LpfCEw",
      "duration": "6:44",
      "creator": "Darth Damian",
      "note": "Expand the movement into a full-body staff and lightsaber pathway."
    },
    {
      "number": "05",
      "title": "Saber Basics: Basic & Figure 8",
      "id": "JYZdbXkeMeQ",
      "duration": "3:36",
      "creator": "Alexis Nieshalla",
      "note": "Learn the grip, basic spin, and Figure 8 in one beginner-friendly lesson."
    },
    {
      "number": "06",
      "title": "Obi-Ani Spin",
      "id": "ACHVeSF9dIw",
      "duration": "5:57",
      "creator": "Alexis Nieshalla",
      "note": "Study the full Obi-Ani pathway with clear movement cues."
    },
    {
      "number": "07",
      "title": "Obi-Ani Spin",
      "id": "pd0TiWDzsFs",
      "duration": "3:32",
      "creator": "Blayne's Adventures",
      "note": "Build the Revenge of the Sith-inspired Obi-Ani pattern step by step."
    }
  ]
};

const icons={"arrow-right":"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNTYgMjU2IiBmaWxsPSJjdXJyZW50Q29sb3IiPjxwYXRoIGQ9Ik0yMjEuNjYsMTMzLjY2bC03Miw3MmE4LDgsMCwwLDEtMTEuMzItMTEuMzJMMTk2LjY5LDEzNkg0MGE4LDgsMCwwLDEsMC0xNkgxOTYuNjlMMTM4LjM0LDYxLjY2YTgsOCwwLDAsMSwxMS4zMi0xMS4zMmw3Miw3MkE4LDgsMCwwLDEsMjIxLjY2LDEzMy42NloiLz48L3N2Zz4=","arrow-left":"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNTYgMjU2IiBmaWxsPSJjdXJyZW50Q29sb3IiPjxwYXRoIGQ9Ik0yMjQsMTI4YTgsOCwwLDAsMS04LDhINTkuMzFsNTguMzUsNTguMzRhOCw4LDAsMCwxLTExLjMyLDExLjMybC03Mi03MmE4LDgsMCwwLDEsMC0xMS4zMmw3Mi03MmE4LDgsMCwwLDEsMTEuMzIsMTEuMzJMNTkuMzEsMTIwSDIxNkE4LDgsMCwwLDEsMjI0LDEyOFoiLz48L3N2Zz4=","play":"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNTYgMjU2IiBmaWxsPSJjdXJyZW50Q29sb3IiPjxwYXRoIGQ9Ik0yMzIuNCwxMTQuNDksODguMzIsMjYuMzVhMTYsMTYsMCwwLDAtMTYuMi0uM0ExNS44NiwxNS44NiwwLDAsMCw2NCwzOS44N1YyMTYuMTNBMTUuOTQsMTUuOTQsMCwwLDAsODAsMjMyYTE2LjA3LDE2LjA3LDAsMCwwLDguMzYtMi4zNUwyMzIuNCwxNDEuNTFhMTUuODEsMTUuODEsMCwwLDAsMC0yN1pNODAsMjE1Ljk0VjQwbDE0My44Myw4OFoiLz48L3N2Zz4=","caret-down":"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNTYgMjU2IiBmaWxsPSJjdXJyZW50Q29sb3IiPjxwYXRoIGQ9Ik0yMTMuNjYsMTAxLjY2bC04MCw4MGE4LDgsMCwwLDEtMTEuMzIsMGwtODAtODBBOCw4LDAsMCwxLDUzLjY2LDkwLjM0TDEyOCwxNjQuNjlsNzQuMzQtNzQuMzVhOCw4LDAsMCwxLDExLjMyLDExLjMyWiIvPjwvc3ZnPg==","x":"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNTYgMjU2IiBmaWxsPSJjdXJyZW50Q29sb3IiPjxwYXRoIGQ9Ik0yMDUuNjYsMTk0LjM0YTgsOCwwLDAsMS0xMS4zMiwxMS4zMkwxMjgsMTM5LjMxLDYxLjY2LDIwNS42NmE4LDgsMCwwLDEtMTEuMzItMTEuMzJMMTE2LjY5LDEyOCw1MC4zNCw2MS42NkE4LDgsMCwwLDEsNjEuNjYsNTAuMzRMMTI4LDExNi42OWw2Ni4zNC02Ni4zNWE4LDgsMCwwLDEsMTEuMzIsMTEuMzJMMTM5LjMxLDEyOFoiLz48L3N2Zz4="};
function init(root){if(root.dataset.initialized)return;root.dataset.initialized='true';
(()=>{const {levels,alternates}=curriculum;
const core=levels.slice(0,3);
const outcomes=['Build control','Connect movements','Build combinations'];
const icon=(name)=>`<img class="icon" src="${icons[name]}" alt="">`;
const esc=(s)=>String(s).replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
const mobile=matchMedia('(max-width:760px)');
const firstLesson=core[0].lessons[0];
const firstLessonFeature=`<div class="feature-video" id="feature-video"><img class="feature-backdrop" alt="" aria-hidden="true"><img class="feature-poster" alt="Original LightsaberBrit Figure 8 video cover"><button class="feature-play" id="feature-play" aria-label="Play Figure 8 here"><span class="feature-play-disc">${icon('play')}</span></button></div><div class="feature-copy"><span class="feature-kicker">START HERE · LESSON 1.1 · ${esc(firstLesson.duration)}</span><h3>Figure 8</h3><p>${esc(firstLesson.note)}</p><span class="feature-credit">Original lesson by ${esc(firstLesson.creator)}</span><button class="feature-next" data-group="${core[0].id}" data-index="1">Next: Reverse Figure 8 ${icon('arrow-right')}</button></div>`;
root.querySelector('#start-module').innerHTML=firstLessonFeature;
root.querySelector('#core-grid').innerHTML=core.map((group,i)=>`<details class="course" id="stage-${group.id}" ${!mobile.matches||i===0?'open':''}><summary><div class="course-label"><span class="course-number">0${i+1}</span><span class="course-count">/ &nbsp; ${group.lessons.length} LESSONS</span><img class="icon course-summary-chevron" src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNTYgMjU2IiBmaWxsPSJjdXJyZW50Q29sb3IiPjxwYXRoIGQ9Ik0yMTMuNjYsMTAxLjY2bC04MCw4MGE4LDgsMCwwLDEtMTEuMzIsMGwtODAtODBBOCw4LDAsMCwxLDUzLjY2LDkwLjM0TDEyOCwxNjQuNjlsNzQuMzQtNzQuMzVhOCw4LDAsMCwxLDExLjMyLDExLjMyWiIvPjwvc3ZnPg==" alt=""></div><h3>${esc(group.name)}</h3><p class="course-outcome">${outcomes[i]}</p></summary><div class="course-list">${group.lessons.map((lesson,j)=>`<button class="course-button" data-group="${group.id}" data-index="${j}"><span class="lesson-number">${esc(lesson.title.match(/^\d\.\d/)?.[0]||lesson.number)}</span><span class="lesson-text">${esc(lesson.title.replace(/^\d\.\d\s*/,''))}</span>${i===0&&j===0?'<span class="lesson-start-label">START</span>':''}</button>`).join('')}</div></details>`).join('');
const libraryLabels=['Skill Extensions','Seven Forms Reference','Flow Analysis'];
const libraryDescriptions=['Specialist moves and combinations from collaborating creators.','Alexis Nieshalla’s complete seven-part reference series.','Study a complete sequence and its technique. Starts at 4:32.'];
root.querySelector('#library-grid').innerHTML=levels.slice(3).map((group,i)=>`<button class="library-card" data-group="${group.id}" data-index="0"><span class="library-topline"><span>${String(i+4).padStart(2,'0')} / OPTIONAL</span><span>${group.lessons.length} ${group.lessons.length===1?'VIDEO':'VIDEOS'}</span></span><span class="library-card-top">${libraryLabels[i]}${icon('arrow-right')}</span><span class="library-description">${libraryDescriptions[i]}</span><span class="library-samples">${group.lessons.slice(0,3).map(lesson=>`<span>${esc(lesson.title)}</span>`).join('')}</span><span class="library-action">${group.lessons.length===1?'Watch the analysis':`Browse all ${group.lessons.length} lessons`} ${icon('arrow-right')}</span></button>`).join('');
root.querySelector('#alternate-list').innerHTML=alternates.map((lesson,i)=>`<button class="alternate-button" data-group="alternates" data-index="${i}"><span>${esc(lesson.title)}<small>${esc(lesson.creator)} · ${esc(lesson.duration)}</small></span>${icon('play')}</button>`).join('');
const allGroups=[...levels,{id:'alternates',name:'Optional coach breakdowns',lessons:alternates}];
const dialog=root.querySelector('#lesson-dialog');
const shell=root.querySelector('#video-shell');
const status=root.querySelector('#playback-status');
let currentGroup=core[0],currentIndex=0,opener=null,player=null,playerToken=0,ytPromise=null,noticeTimer=null;
const featureVideo=root.querySelector('#feature-video');
const featureOriginal=featureVideo.innerHTML;
const featureButton=()=>root.querySelector('#feature-play');
function resetFeature(){if(featureVideo.querySelector('iframe')){featureVideo.innerHTML=featureOriginal;setFeatureCover();}}
function setFeatureCover(){featureVideo.querySelectorAll('.feature-backdrop,.feature-poster').forEach(img=>thumbnail(img,firstLesson.id));}
setFeatureCover();
featureVideo.addEventListener('click',event=>{if(!event.target.closest('#feature-play'))return;const frame=document.createElement('iframe');const params=new URLSearchParams({autoplay:'1',rel:'0',playsinline:'1'});frame.src=`https://www.youtube-nocookie.com/embed/${firstLesson.id}?${params}`;frame.title=`${firstLesson.title} — ${firstLesson.creator}`;frame.allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';frame.allowFullscreen=true;frame.referrerPolicy='strict-origin-when-cross-origin';featureVideo.replaceChildren(frame);});
function destroyPlayer(){playerToken++;clearTimeout(noticeTimer);if(player){try{player.destroy()}catch{}}player=null;shell.replaceChildren();status.hidden=true;}
function thumbnail(img,id){let fallback=false;img.addEventListener('load',()=>{if(img.naturalWidth<200&&!fallback){fallback=true;img.src=`https://i.ytimg.com/vi/${id}/hqdefault.jpg`;}});img.addEventListener('error',()=>{if(!fallback){fallback=true;img.src=`https://i.ytimg.com/vi/${id}/hqdefault.jpg`;}else{img.hidden=true;if(img.classList.contains('poster')){const text=document.createElement('span');text.className='poster-failure';text.textContent='Cover unavailable — play the original video';shell.querySelector('.play-video')?.append(text);}}});img.src=`https://i.ytimg.com/vi/${id}/maxresdefault.jpg`;}
function renderLesson(){
  destroyPlayer();const lesson=currentGroup.lessons[currentIndex];
  root.querySelector('#dialog-group').textContent=currentGroup.name;
  root.querySelector('#lesson-title').textContent=lesson.title;
  root.querySelector('#lesson-position').textContent=`LESSON ${currentIndex+1} OF ${currentGroup.lessons.length}`;
  root.querySelector('#lesson-meta').textContent=`${lesson.creator} · ${lesson.duration}${lesson.start?' · Starts at 4:32':''}`;
  root.querySelector('#lesson-note').textContent=lesson.note;
  root.querySelector('#playlist-heading').textContent=currentGroup.name;
  root.querySelector('#playlist-count').textContent=`${currentGroup.lessons.length} ${currentGroup.lessons.length===1?'lesson':'lessons'}`;
  shell.innerHTML=`<img class="backdrop" alt="" aria-hidden="true"><img class="poster" alt="${esc(lesson.title)} — original video cover"><button class="play-video" aria-label="Play ${esc(lesson.title)}"><span class="play-disc">${icon('play')}</span></button>`;
  shell.querySelectorAll('img:not(.icon)').forEach(img=>thumbnail(img,lesson.id));
  shell.querySelector('.play-video').addEventListener('click',startPlayback);
  root.querySelector('#playlist-items').innerHTML=currentGroup.lessons.map((item,i)=>`<button class="playlist-button" data-playlist-index="${i}" ${i===currentIndex?'aria-current="true"':''}><span>${esc(item.title)}</span><small>${esc(item.duration)}</small></button>`).join('');
  const groupIndex=core.findIndex(group=>group.id===currentGroup.id);
  root.querySelector('#previous').disabled=currentIndex===0&&groupIndex<=0;
  root.querySelector('#next').disabled=currentIndex===currentGroup.lessons.length-1&&(groupIndex===-1||groupIndex===2);
  root.querySelector('#next').innerHTML=currentIndex===currentGroup.lessons.length-1&&groupIndex>=0&&groupIndex<2?`Next stage ${icon('arrow-right')}`:`Next lesson ${icon('arrow-right')}`;
  root.querySelectorAll('.course-button').forEach(button=>{const selected=button.dataset.group===currentGroup.id&&+button.dataset.index===currentIndex;button.classList.toggle('is-selected',selected);if(selected)button.setAttribute('aria-current','true');else button.removeAttribute('aria-current');});
}
function openLesson(groupId,index,trigger){resetFeature();currentGroup=allGroups.find(group=>group.id===groupId)||core[0];currentIndex=Math.max(0,Math.min(index,currentGroup.lessons.length-1));opener=trigger;renderLesson();if(!dialog.open)dialog.showModal();root.classList.add('has-dialog');dialog.scrollTop=0;root.querySelector('#close-player').focus({preventScroll:true});}
root.addEventListener('click',event=>{const button=event.target.closest('[data-group]');if(button)openLesson(button.dataset.group,+button.dataset.index,button);});
root.querySelector('#start').addEventListener('click',()=>{root.querySelector('#stage-foundations').open=true;featureVideo.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth',block:'center'});featureButton()?.focus({preventScroll:true});});
root.querySelector('#close-player').addEventListener('click',()=>dialog.close());
dialog.addEventListener('close',()=>{destroyPlayer();root.classList.remove('has-dialog');opener?.focus({preventScroll:true});});
dialog.addEventListener('click',event=>{if(event.target!==dialog)return;const box=dialog.getBoundingClientRect();if(event.clientX<box.left||event.clientX>box.right||event.clientY<box.top||event.clientY>box.bottom)dialog.close();});
root.querySelector('#playlist-items').addEventListener('click',event=>{const button=event.target.closest('[data-playlist-index]');if(!button)return;currentIndex=+button.dataset.playlistIndex;renderLesson();dialog.scrollTo({top:0,behavior:mobile.matches?'instant':'smooth'});shell.querySelector('.play-video').focus({preventScroll:true});});
function navigateLesson(step){const groupIndex=core.findIndex(group=>group.id===currentGroup.id);const next=currentIndex+step;if(next<0&&groupIndex>0){currentGroup=core[groupIndex-1];currentIndex=currentGroup.lessons.length-1;}else if(next>=currentGroup.lessons.length&&groupIndex>=0&&groupIndex<2){currentGroup=core[groupIndex+1];currentIndex=0;}else if(next>=0&&next<currentGroup.lessons.length)currentIndex=next;else return;renderLesson();dialog.scrollTop=0;shell.querySelector('.play-video').focus({preventScroll:true});}
root.querySelector('#next').addEventListener('click',()=>navigateLesson(1));
root.querySelector('#previous').addEventListener('click',()=>navigateLesson(-1));
mobile.addEventListener('change',()=>root.querySelectorAll('.course').forEach((node,i)=>node.open=!mobile.matches||i===0));
function loadYouTube(){if(window.YT?.Player)return Promise.resolve();if(ytPromise)return ytPromise;ytPromise=new Promise((resolve,reject)=>{window.onYouTubeIframeAPIReady=resolve;const script=document.createElement('script');script.src='https://www.youtube.com/iframe_api';script.onerror=reject;document.head.append(script);});return ytPromise;}
function showPlaybackMessage(message){status.textContent=message;status.hidden=false;}
async function startPlayback(){
  const lesson=currentGroup.lessons[currentIndex];destroyPlayer();const token=playerToken;
  const params=new URLSearchParams({autoplay:'1',rel:'0',playsinline:'1',enablejsapi:'1',origin:location.origin});if(lesson.start)params.set('start',String(lesson.start));
  const frame=document.createElement('iframe');frame.id='yt-player';frame.src=`https://www.youtube-nocookie.com/embed/${lesson.id}?${params}`;frame.title=lesson.title;frame.allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';frame.allowFullscreen=true;frame.referrerPolicy='strict-origin-when-cross-origin';shell.append(frame);
  noticeTimer=setTimeout(()=>{if(token===playerToken)showPlaybackMessage('If playback has not started, press play in the video. Availability may depend on the creator, your region or your browser settings.');},14000);
  try{await loadYouTube();if(token!==playerToken||!dialog.open)return;player=new window.YT.Player(frame,{events:{onStateChange:event=>{if(event.data===1){clearTimeout(noticeTimer);status.hidden=true;}},onError:()=>{clearTimeout(noticeTimer);showPlaybackMessage('This video could not play here. It may be restricted by the creator or unavailable on this connection. You can choose another lesson without leaving the academy.');}}});}catch{if(token===playerToken)showPlaybackMessage('The video player could not fully connect. You can retry this lesson or select another video.');}
}
})();
(()=>{
const core = curriculum.levels.slice(0,3);
const names = ['Foundations','Transitions','Performance'];
const cues = ['Learn the wrist paths','Connect grips and movements','Build your combinations'];
const icon = name => `<img class="icon" src="${icons[name]}" alt="">`;
const escape = s => String(s).replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
function cover(img,id){
  let fallback=false;
  const useFallback=()=>{if(!fallback){fallback=true;img.src=`https://i.ytimg.com/vi/${id}/hqdefault.jpg`;}else img.hidden=true;};
  img.addEventListener('error',useFallback);
  img.addEventListener('load',()=>{if(img.naturalWidth<200&&!fallback)useFallback();});
  img.src=`https://i.ytimg.com/vi/${id}/maxresdefault.jpg`;
}
root.querySelectorAll('.library-card').forEach((card,i)=>{
  const group=curriculum.levels[i+3];
  const art=document.createElement('span');art.className='library-cover';
  art.innerHTML=`<img class="cover-blur" alt="" aria-hidden="true"><img alt="Original video cover: ${escape(group.lessons[0].title)}" loading="lazy">`;
  card.prepend(art);art.querySelectorAll('img').forEach(img=>cover(img,group.lessons[0].id));
});
const route = root.querySelector('#learning-route');
if (route) route.innerHTML = core.map((group,i)=>`<a href="#stage-${group.id}"><span class="route-node">0${i+1}</span><span><strong>${names[i]}</strong><small>${cues[i]} · 6 lessons</small></span>${i<2?icon('arrow-right'):''}</a>`).join('');

if (root.classList.contains('studio')) {
  root.querySelector('#studio-tabs').innerHTML = core.map((group,i)=>`<button id="tab-${group.id}" role="tab" aria-controls="stage-${group.id}" aria-selected="${i===0}" tabindex="${i===0?0:-1}" data-stage="${i}"><span>0${i+1}</span>${names[i]}<small>6 lessons</small></button>`).join('');
  root.querySelector('#studio-workspace').append(root.querySelector('#core-grid'));
  root.querySelector('.curriculum-intro').innerHTML = '<p>THE COMPLETE CORE SERIES</p><span>18 lessons in the creator’s original order. Switch stages above to explore all three.</span>';
  let stage=0,index=0;
  const feature=root.querySelector('#feature-video');
  const copy=root.querySelector('#start-module .feature-copy');
  const tabs=[...root.querySelectorAll('[data-stage]')];
  const panels=[...root.querySelectorAll('.course')];
  const sequence=core.flatMap((group,stageIndex)=>group.lessons.map((lesson,lessonIndex)=>({stage:stageIndex,index:lessonIndex,lesson})));
  root.querySelectorAll('.course-button').forEach(button=>{
    const group=core.find(group=>group.id===button.dataset.group);
    const duration=document.createElement('span');duration.className='lesson-duration';duration.textContent=group.lessons[+button.dataset.index].duration;button.append(duration);
  });
  function render(scroll=false){
    const group=core[stage],lesson=group.lessons[index];
    tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',String(i===stage));tab.tabIndex=i===stage?0:-1;});
    panels.forEach((panel,i)=>{panel.classList.toggle('active-stage',i===stage);panel.open=true;panel.setAttribute('role','tabpanel');panel.setAttribute('aria-labelledby',tabs[i].id);panel.hidden=i!==stage;});
    root.querySelectorAll('.course-button').forEach(button=>{const selected=button.dataset.group===group.id&&+button.dataset.index===index;button.classList.toggle('is-selected',selected);if(selected)button.setAttribute('aria-current','true');else button.removeAttribute('aria-current');});
    feature.innerHTML=`<img class="feature-backdrop" alt="" aria-hidden="true"><img class="feature-poster" alt="${escape(lesson.title)} — original video cover"><button class="feature-play" id="feature-play" aria-label="Play ${escape(lesson.title)} here"><span class="feature-play-disc">${icon('play')}</span></button>`;
    feature.querySelectorAll('.feature-backdrop,.feature-poster').forEach(img=>cover(img,lesson.id));
    const position=sequence.findIndex(item=>item.stage===stage&&item.index===index);
    copy.innerHTML=`<span class="feature-kicker">${names[stage].toUpperCase()} · LESSON ${position+1} OF 18 · ${lesson.duration}</span><h3>${escape(lesson.title.replace(/^\d\.\d\s*/,''))}</h3><p>${escape(lesson.note)}</p><span class="feature-credit">Original lesson by ${escape(lesson.creator)}</span><div class="inline-controls"><button id="inline-prev" ${position===0?'disabled':''}>${icon('arrow-left')} Previous</button><button id="inline-next" ${position===17?'disabled':''}>${position===17?'End of core series':index===5?'Next stage':'Next lesson'} ${icon('arrow-right')}</button></div>`;
    copy.querySelector('#inline-prev').addEventListener('click',()=>move(-1));
    copy.querySelector('#inline-next').addEventListener('click',()=>move(1));
    if(scroll)feature.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth',block:'start'});
  }
  function move(step){const position=sequence.findIndex(item=>item.stage===stage&&item.index===index);const next=sequence[position+step];if(next){stage=next.stage;index=next.index;render(true);copy.querySelector(step<0?'#inline-prev':'#inline-next').focus({preventScroll:true});}}
  tabs.forEach((tab,i)=>{
    tab.addEventListener('click',()=>{stage=i;index=0;render();});
    tab.addEventListener('keydown',event=>{let target;if(event.key==='ArrowRight')target=(i+1)%3;if(event.key==='ArrowLeft')target=(i+2)%3;if(event.key==='Home')target=0;if(event.key==='End')target=2;if(target!==undefined){event.preventDefault();stage=target;index=0;render();tabs[target].focus();}});
  });
  root.addEventListener('click',event=>{
    const button=event.target.closest('.course-button');
    if(!button)return;
    event.stopImmediatePropagation();stage=core.findIndex(group=>group.id===button.dataset.group);index=+button.dataset.index;render(true);
    feature.querySelector('#feature-play').focus({preventScroll:true});
  },true);
  feature.addEventListener('click',event=>{
    if(!event.target.closest('#feature-play'))return;
    event.stopImmediatePropagation();
    const lesson=core[stage].lessons[index],frame=document.createElement('iframe');
    frame.src=`https://www.youtube-nocookie.com/embed/${lesson.id}?autoplay=1&rel=0&playsinline=1`;
    frame.title=`${lesson.title} — ${lesson.creator}`;frame.allow='autoplay; encrypted-media; fullscreen; picture-in-picture';frame.allowFullscreen=true;frame.referrerPolicy='strict-origin-when-cross-origin';
    feature.replaceChildren(frame);
  },true);
  root.querySelector('#start').addEventListener('click',event=>{event.stopImmediatePropagation();stage=0;index=0;render(true);feature.querySelector('#feature-play').focus({preventScroll:true});},true);
  root.querySelector('.hero .text-link').href='#libraries';
  // Opening an optional lesson must stop any core video, including after switching stages.
  root.addEventListener('click',event=>{if(event.target.closest('.library-card,.alternate-button')&&feature.querySelector('iframe'))render();},true);
  matchMedia('(max-width:760px)').addEventListener('change',()=>panels.forEach(panel=>panel.open=true));
  render();
}

root.addEventListener('click',event=>{
  const course=event.target.closest('[data-practice-stage]');
  if(course){
    const tab=root.querySelector(`[data-stage="${course.dataset.practiceStage}"]`);
    tab?.click();root.querySelector('#core')?.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth',block:'start'});
    tab?.focus({preventScroll:true});
  }
  if(event.target.closest('.next-help'))root.querySelector('#alternate-section').open=true;
});
const missionTabs=[...root.querySelectorAll('[data-mission]')];
function chooseMission(index){
  missionTabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',String(i===index));tab.tabIndex=i===index?0:-1;root.querySelector(`#mission-panel-${i}`).hidden=i!==index;});
}
missionTabs.forEach((tab,index)=>{
  tab.addEventListener('click',()=>chooseMission(index));
  tab.addEventListener('keydown',event=>{
    let next;
    if(event.key==='ArrowRight')next=(index+1)%3;
    if(event.key==='ArrowLeft')next=(index+2)%3;
    if(event.key==='Home')next=0;
    if(event.key==='End')next=2;
    if(next!==undefined){event.preventDefault();chooseMission(next);missionTabs[next].focus();}
  });
});
})();
root.addEventListener('click',e=>{const a=e.target.closest('a[href^="#"]');if(a){const target=root.querySelector(a.getAttribute('href'));if(target){e.preventDefault();target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});}}});
}
document.querySelectorAll('[data-ns-spin]').forEach(init);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-ns-spin]').forEach(init));
})();